import React from 'react'
import { Geometry, Base, Subtraction } from '@react-three/csg'

export const Column = ({ position, scale = 1 }) => {
	return (
		<mesh position={position} scale={scale}>
			{/* <meshStandardMaterial color={'lightgray'} /> */}
			<meshStandardMaterial color={'#fff'} />
			<Geometry>
				<Base>
					<cylinderGeometry args={[10, 10, 100]} />
				</Base>
				<Subtraction position={[5, 70, -0.7]} rotation={[Math.PI / 2, 0, 0]}>
					<sphereGeometry args={[30, 20, 20]} />
				</Subtraction>
			</Geometry>
		</mesh>
	)
}
